import { AutogenLayoutMobileCommLandmark } from "./autogen/AutogenLayoutMobileCommLandmark";

export class MobileCommLandmark extends AutogenLayoutMobileCommLandmark {
    override onLoad(): void {
    }
}
